import { Aseprite } from "@/game/libs/engine/sprite/aseprite";
import { PlayerDirection } from "@/game/skifree/controller/Controller";
import { Sprite } from "pixi.js";

export class Player {
  public jumpingElapsed: number = 0;
  public isCrashed: boolean = false;
  public x: number;
  public y: number;
  public lifeCount: number;
  public veloX: number;
  public veloY: number;
  public angle: number;
  public sprite: Aseprite;
  public shadow: Sprite;
  public direction: PlayerDirection;
  public endGame: (points: number) => void;

  constructor(
    x: number,
    y: number,
    lifeCount: number,
    veloX: number,
    veloY: number,
    direction: PlayerDirection,
    sprite: Aseprite,
    shadow: Sprite,
    endGame: (points: number) => void
  ) {
    this.x = x;
    this.y = y;
    this.lifeCount = lifeCount;
    this.veloX = veloX;
    this.veloY = veloY;
    this.angle = 0;
    this.direction = direction;
    this.sprite = sprite;
    this.shadow = shadow;
    this.endGame = endGame;
  }

  reset() {
    this.jumpingElapsed = 0;
    this.isCrashed = false;
    this.x = 0;
    this.y = 0;
    this.lifeCount = 0;
    this.veloX = 0;
    this.veloY = 0;
    this.angle = 0;
    this.sprite = null as any;
    this.shadow = null as any;
    this.endGame = null as any;
  }
}

export type PlayerStateChange = ((player: Player) => void) | null;
